import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.floranya.co',
});

// Login API
export const login = async (email, password) => {
  const response = await api.post('/login', { email, password });
  return response.data;
};

// Category APIs
export const getCategories = async () => {
  const response = await api.get('/menu', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return response.data;
};

export const addCategory = async (categoryData) => {
  
  const response = await api.post('/categories', categoryData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateCategory = async (id, formData) => {
  console.log('FormData entries in updateCategory:');
  for (let pair of formData.entries()) {
    console.log(pair[0], pair[1]);
  }
  const response = await api.post(`/categories/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  console.log(response.data);
  return response.data;
};

export const deleteCategory = async (id) => {
  await api.delete(`/categories/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
};

// Item APIs
export const getItemsByCategory = async (categoryId) => {
  const response = await api.get(`/items?category_id=${categoryId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return response.data;
};

export const addItem = async (itemData) => {
  const response = await api.post('/items', itemData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateItem = async (id, itemData) => {
  try {
    // For debugging purposes
    for (let pair of itemData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    const response = await api.post(`/items/${id}?_method=PUT`, itemData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  } catch (error) {
    console.error('Error updating item:', error.response?.data || error.message);
    throw error;
  }
};

export const deleteItem = async (id) => {
  await api.get(`/itemDelete/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
};


export const getSliderImages = async (id) => {
  const response = await api.get(`/slider`);
  return response.data;
};

// Add a new slider image (POST /slider)
export const addSliderImage = async (formData) => {
  console.log(`api/slider`)
  const response = await api.post('/slider', formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data; // Returns updated array of sliders
};

// Delete a slider image (DELETE /slider/{id})
export const deleteSliderImage = async (id) => {
  const response = await api.delete(`/slider/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return response.data; // Returns updated array of sliders
};

